// extracted by mini-css-extract-plugin
export var dropdown = "_jg-1";
export var hidden = "_jg-0";